// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"404":"AwesomeSezzle-ef9ff6f8","825":"AwesomeSezzle-c8bb776f"}[chunkId] + ".bundle." + {"404":"11b7266a8d37b1858cf8","825":"d96da295224d1d7d0914"}[chunkId] + ".js";
};